export default "__VITE_ASSET__99d1d1e3__"